import { Query } from 'graphql/generated/graphqlTypes';
import { mockVisitorsInstallersAndCleaners } from 'mocks/graphqlMocks/visitorFixtures';

export function mockedGetVisitorsWithoutNestedResolversData(
  getVisitors: Query['getVisitors']
): Pick<Query, 'getVisitors'> {
  return { getVisitors };
}

export const mockedGetVisitorsWithoutNestedResolversDataForQuery = mockedGetVisitorsWithoutNestedResolversData(
  mockVisitorsInstallersAndCleaners
);
